<ng-container *ngIf="!isLoading; else spinner">
  <h1 mat-dialog-title>Add {{ facilityTitleType }} to {{ airport.name }}</h1>
  <mat-dialog-content>
    <p>Submit a {{ facilityType }} to have it included in the AOPA Airport Directory. This is available free
    to anyone with a free AOPA web user account.  All new {{ facilityType }} submissions will
    be hidden from the public until approved by AOPA staff.</p>

    <p *ngIf="!loggedIn" class="submit-new-business__alert">Since you are not logged in, you will be prompted to log in or create a free
    account upon pressing Submit.</p>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="onSubmit()">Continue</button>
    <button mat-button mat-dialog-close>Cancel</button>
  </mat-dialog-actions>
</ng-container>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner class="spinner" [diameter]="200" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
